import { render, staticRenderFns } from "./ExamFailCount.vue?vue&type=template&id=05d1c5e7&scoped=true"
import script from "./ExamFailCount.vue?vue&type=script&lang=js"
export * from "./ExamFailCount.vue?vue&type=script&lang=js"
import style0 from "./ExamFailCount.vue?vue&type=style&index=0&id=05d1c5e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d1c5e7",
  null
  
)

export default component.exports